import React, { useState } from 'react';
import './RegisterForm.css';
import { FaLanguage } from 'react-icons/fa';

export default function RegisterForm({ onRegister, isTamil, toggleLanguage }) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    address: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onRegister(formData);
  };

  return (
    <section id="register">
      <div className="register-form-container">
        <h2>{isTamil ? 'தமிழ்மணமலை அறக்கட்டளையில் இலவசமாக பதிவு செய்யுங்கள்' : 'Register for TamilManaMalai Trust Free'}</h2>
        <p style={{ marginTop: '10px', fontSize: '16px', color: '#555' }}>
          {isTamil
            ? 'இது ஒரு இலவச பதிவு ஆகும். நீங்கள் பதிவு செய்த பிறகு, இலவசமாக பதிவிறக்கம் செய்யக்கூடிய ஒரு டிஜிட்டல் அட்மிட் கார்டு பெறுவீர்கள்.'
            : "It's a free registration. Once registered, you will receive a digital admit card which you can download at no cost."}
        </p>
        <h3 style={{ marginTop: '20px', fontWeight: '600', color: '#2e7d32' }}>
          {isTamil ? 'எங்கள் குழுவில் சேருங்கள் 😊' : 'Join Our Team 😊'}
        </h3>

        <button
          onClick={toggleLanguage}
          type="button"
          style={{
            marginTop: '10px',
            marginBottom: '20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            padding: '8px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
          }}
        >
          <FaLanguage />
          {isTamil ? 'Translate to English' : 'Translate to தமிழ்'}
        </button>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder={isTamil ? 'முழு பெயர்' : 'Full Name'}
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={isTamil ? 'மின்னஞ்சல்' : 'Email'}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder={isTamil ? 'தொலைபேசி எண்' : 'Phone'}
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <textarea
            name="address"
            placeholder={isTamil ? 'முகவரி' : 'Address'}
            value={formData.address}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">{isTamil ? 'பதிவுசெய்க' : 'Register'}</button>
        </form>
      </div>
    </section>
  );
}
  